import { useEffect, useState } from "react";
import {
  DEFAULT_DEPLOYMENT_MODE,
  deploymentModeService,
  type DeploymentMode,
} from "../services/deploymentModeService";

/** Deployment mode of the backend (on-prem hides limits and SaaS-only screens). */
export function useDeploymentMode(): DeploymentMode & { loading: boolean } {
  const [mode, setMode] = useState<DeploymentMode | null>(deploymentModeService.peek());

  useEffect(() => {
    if (mode) return;
    let cancelled = false;
    deploymentModeService.get().then((value) => {
      if (!cancelled) setMode(value);
    });
    return () => {
      cancelled = true;
    };
  }, [mode]);

  return { ...(mode ?? DEFAULT_DEPLOYMENT_MODE), loading: mode === null };
}
